import React from "react";

import styles from "./styles.module.scss";

export const HorizontalBorder = () => <div className={styles.HorizontalRow} />;
